const macroPercentage = (macro, total) => {
  if (!total) {
    return 0;
  }

  return Math.round((macro / total) * 100);
};

export { macroPercentage };
